"use client";
import { useLocale } from "next-intl";
import PricingGlobal from "@/features/billing/ui/pricing/PricingGlobal";
import PricingKorean from "@/features/billing/ui/pricing/PricingKorean";
import { Footer } from "@/shared/ui/layout/footer/Footer";

const PricingWidget = () => {
  const locale = useLocale();

  if (locale !== "ko") {
    return <PricingGlobal />;
  }
  return (
    <>
      <PricingKorean />
      <Footer />
    </>
  );
};

export default PricingWidget;
